import { combineReducers } from "redux";

import settingsReducer from "./settings.reducer.js";
import themesReducer from "./themes.reducers.js";
import formReducer from "./form.reducer.js";
import loginReducer from "./login.reducer.js";
import profileReducer from "./profile.reducer.js";
import snackbarReducer from "./snackbar.reducer.js";
import userDetailsReducer from "./userDetails.reducer.js";
import userReducer from "./user.reducer.js";
import pumpSelectionReducer from "./pumpSelection.reducers.js";
import plcReducer from "./plc.reducer.js";
import maintenanceReducer from "./maintenance.reducer.js";

export default combineReducers({
  settings: settingsReducer,
  theme: themesReducer,
  form: formReducer,
  login: loginReducer,
  profile: profileReducer,
  snackbar: snackbarReducer,
  userDetails: userDetailsReducer,
  user: userReducer,
  pumpSelection: pumpSelectionReducer,
  pressureLoss: plcReducer,
  capsMaintenance: maintenanceReducer
});
